// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2hiKc","bigColWidth":"Table_bigColWidth__1jySP","biggerColWidth":"Table_biggerColWidth__3U3Rd","row":"Table_row__1T_4u","col":"Table_col__9WLw8"};